import { buildApiParamsPagination } from '@sonifi/wb-widget/store/tableConfig/tableConfigInitialState';
import { store } from '@sonifi/wb-core/store/store';
import {
  getGuestRequestOrders,
  getOrderById,
  initRowExpanded,
} from '../Orders/services/grOrders.service';
import { TABLE_KEYS } from '@sonifi/wb-widget/store/tableConfig/tableConfigConstants';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

function checkIfGrOrdersAreLoaded(apiParams) {
  const state = store.getState();
  const {
    guestRequestOrders: { loadingOrders, orders },
  } = state;
  const currentPagination =
    state.tableConfig.pagination[TABLE_KEYS.guestRequestOrders];

  // If orders are loaded and params match, just update expanded state without refetching
  if (
    loadingOrders === LOADING_STATUS.success &&
    orders.length > 0 &&
    currentPagination &&
    currentPagination.page === apiParams.page &&
    currentPagination.pageSize === apiParams.pageSize &&
    currentPagination.query === apiParams.query &&
    currentPagination.sortBy === apiParams.sortBy &&
    currentPagination.sortDir === apiParams.sortDir
  ) {
    return true;
  }
  return false;
}

export async function loaderGrOrders({ request }) {
  store.dispatch(initRowExpanded(null));

  const apiParams = buildApiParamsPagination(request);

  if (checkIfGrOrdersAreLoaded(apiParams)) {
    return {};
  }
  await store.dispatch(getGuestRequestOrders(apiParams));
  return {};
}

export async function loaderGrOrderById({ params, request }) {
  const { id } = params;
  const expandedRowId = parseInt(id);

  const apiParams = buildApiParamsPagination(request);
  if (!checkIfGrOrdersAreLoaded(apiParams)) {
    await loaderGrOrders({ request });
  }

  store.dispatch(initRowExpanded(expandedRowId));
  if (expandedRowId) {
    // Don't wait here because uses the internal loading in the WbTable
    store.dispatch(getOrderById(expandedRowId));
  }
  return {};
}
